import {
    creationTaskToPreviewSingleVoyage
} from "@containers/singleVoyage/tasks/helpers/executions";
import React, {SyntheticEvent} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {Box, Paper, Stack, Typography} from '@mui/material';
import {classNames} from "@helpers/classNames";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import DeleteIcon from '@mui/icons-material/Delete';
import {
	MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY
} from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/constants";
import SteepItemCircleSingleVoyage
	from "@containers/singleVoyage/views/stepperLine/steepItem/SteepItemCircleSingleVoyage";
import {
	OnClickPointMutateSingleVoyage,
	onDeletePointCbMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/types/events";
import {IWayPointCreationMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/points/types";
import PointTasksMiniInfoMutateSingleVoyage
	from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/pointItem/tasksMiniInfo/PointTasksMiniInfoMutateSingleVoyage";

import {sx} from './sx'
import OpenWithIcon from '@mui/icons-material/OpenWith';
import PointTasksInfoSmallViewSingleVoyage
	from "@containers/singleVoyage/tasks/views/pointTasksInfo/PointTasksInfoSmallViewSingleVoyage";
import StatusBarPointViewSingleVoyage
	from "@containers/singleVoyage/containers/points/views/pointInfo/statusBar/StatusBarPointViewSingleVoyage";
import {
	getPointColorByStatusSecondarySingleVoyage,
	getPointTextColorByStatusSecondarySingleVoyage
} from "@containers/singleVoyage/containers/points/helpers/colors";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import {
	PointTemplateInfoSmallSingleVoyage
} from "@containers/singleVoyage/pointTemplates/pointTemplateInfo/PointTemplateInfoSmallSingleVoyage";
import {
	TrackableObjectsInfoSingleVoyage
} from "@containers/singleVoyage/trackableObjects/trackableObjectsInfo/TrackableObjectsInfoSingleVoyage";

interface IProps {
	point: IWayPointCreationMutateSingleVoyage
	index: number
	active?: boolean
	onDelete?: onDeletePointCbMutateSingleVoyage
	onClickPoint?: OnClickPointMutateSingleVoyage
	disabled?: boolean,
	voyageStatus: VoyageStatusSingleVoyage
	accountId: string | number
}

const PointItemMutateSingleVoyage = ({
										 point,
										 index,
										 active,
										 onDelete,
										 disabled,
										 onClickPoint,
										 voyageStatus,
										 accountId,
									 }: IProps) => {
	// Labels for every stop of the voyage: a task may cover more than this one.
	const {points: allPoints} = useRootContextMutateSingleVoyage()
	const handleDelete = async (e: SyntheticEvent) => {
		e.preventDefault()
		e.stopPropagation()
		await onDelete({
			point,
			index
		})
	}
	const hasTasks = point.tasks?.length >= 1
	const pointColor = getPointColorByStatusSecondarySingleVoyage(point?.status)
	const pointTextColor = getPointTextColorByStatusSecondarySingleVoyage(point?.status)
	
	return (
		<Stack
			sx={sx.root}
			gap={'10px'}
			direction={'row'}
			alignItems={'stretch'}
			justifyContent={'stretch'}
		>
			<SteepItemCircleSingleVoyage
				number={index + 1}
				backgroundColor={pointColor}
				color={pointTextColor}
			/>
			
			<Box
				sx={sx.inner}
			>
				<Box
					sx={sx.cardInner}
					className={classNames(onClickPoint && 'hover')}
					onClick={onClickPoint ? () => onClickPoint(point) : undefined}
				>
					<Paper
						sx={sx.card}
						className={classNames(
							active && 'active', hasTasks && 'hasTasks',
							(
								point.status === 'COMPLETED' ||
								point.status === 'PARTIAL_COMPLETED'
							) && 'complete'
						)}
					>
						
						<Stack
							direction={'row'}
							justifyContent={'flex-end'}
							gap={'5px'}
						>
							{onDelete && <IconButtonCustom
                                variant={'empty'}
                                onClick={handleDelete}
                                disabled={disabled}
                            >
                                <DeleteIcon/>
                            </IconButtonCustom>}
							
							<IconButtonCustom
								variant={'empty'}
								disabled={disabled}
								className={MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY}
							>
								<OpenWithIcon/>
							</IconButtonCustom>
						</Stack>
						
						<Stack
							direction={'row'}
							gap={1}
							flexWrap={'wrap'}
						>
							{
								(
									point.status === 'COMPLETED' ||
									point.status === 'PARTIAL_COMPLETED'
								)
								&& <StatusBarPointViewSingleVoyage
                                    status={point?.status}
                                />}
							
							{hasTasks && <PointTasksMiniInfoMutateSingleVoyage tasks={point.tasks}/>}
						</Stack>
						
						
						<Typography
							sx={sx.name}
							variant={'body2'}
						>
							{point.name}
						</Typography>
					</Paper>
					
					
					{point.waypointTemplate && <PointTemplateInfoSmallSingleVoyage
                        pointTemplate={point.waypointTemplate}
                    />}
					
					{point?.waypointTemplate?.trackableObjects && <TrackableObjectsInfoSingleVoyage
                        trackableObjects={point.waypointTemplate?.trackableObjects}
                    />}
					
					{hasTasks &&
                        <PointTasksInfoSmallViewSingleVoyage
                            sx={sx.tasksInfo}
                            tasks={(point.tasks ?? []).map(creationTaskToPreviewSingleVoyage)}
                            currentWaypointId={Number(point.id)}
                            narrowToWaypoint
                            accountId={accountId}
                        />}
				</Box>
			</Box>
		
		</Stack>
	);
};

export default PointItemMutateSingleVoyage;
